export function shouldAutoplayEpisode(search: string): boolean {
    const params = new URLSearchParams(search);

    return params.get('autoplay') === '1';
}
